import '.n{position:relative;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.i{flex-direction:column;}.ssr-plugin'
import '.fj{padding:8px;}.ssr-plugin'
import { useState } from 'react'
import { colors } from '../../tokens/colors.js'
import { radius } from '../../utils/radius.js'
import { styled } from 'inlines'
import { CheckboxInput } from '../CheckboxInput/index.js'
import { Menu } from '../Menu/index.js'
import { IconButton } from '../IconButton/index.js'
import { Text } from '../Text/index.js'
import { GridMediaItem } from './GridMediaItem.js'
import { InternalGridProps, getFieldPriorityByType } from './index.js'

type GridItemProps = {
  data: any
  fields: Record<any, any>
  onClick?: () => void
} & Pick<InternalGridProps, 'select' | 'onSelectChange' | 'itemActions'>

export const GridItem = ({
  data,
  fields,
  select,
  onSelectChange,
  onClick,
  itemActions,
}: GridItemProps) => {
  const selected = select?.includes(data.id)
  const [forceHover, setForceHover] = useState(false)

  return (
    <styled.div className="n a i fj"
      onClick={onClick}
      data-selected={selected ? true : undefined}
      data-forcehover={forceHover ? true : undefined}
      style={{
        borderRadius: radius[16],
        '&:hover, &[data-selected], &[data-forcehover]': {
          background: colors.neutral10Adjusted,
        },
        '&:hover > .selectContainer, &[data-selected] > .selectContainer, &[data-forcehover] > .selectContainer':
          {
            opacity: '100% !important',
          },
        '&:hover > .actionContainer, &[data-selected] > .actionContainer, &[data-forcehover] > .actionContainer':
          {
            opacity: '100% !important',
          },
      }}
    >
      {onSelectChange && (
        <div
          className="selectContainer"
          style={{
            position: 'absolute',
            top: 16,
            left: 16,
            opacity: 0,
            height: 32,
            width: 32,
            borderRadius: radius[8],
            background: colors.neutralInverted100,
            overflow: 'hidden',
          }}
          onClick={(e) => {
            e.stopPropagation()
          }}
        >
          <div
            style={{
              width: '100%',
              height: '100%',
              background: colors.neutral10Adjusted,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <CheckboxInput
              value={selected}
              onChange={() => {
                if (!select) {
                  onSelectChange([data.id])
                  return
                }
                if (select.includes(data.id)) {
                  onSelectChange(select.filter((e) => e !== data.id))
                  return
                }
                onSelectChange([...select, data.id])
              }}
            />
          </div>
        </div>
      )}
      {itemActions && (
        <div
          className="actionContainer"
          style={{
            position: 'absolute',
            top: 16,
            right: 16,
            opacity: 0,
            height: 32,
            width: 32,
            borderRadius: radius[8],
            background: colors.neutralInverted100,
            overflow: 'hidden',
          }}
          onClick={(e) => {
            e.stopPropagation()
          }}
        >
          <Menu
          // onOpenChange={(open) => {
          //   setForceHover(open ? true : false)
          // }}
          >
            <Menu.Trigger>
              <div
                onClick={(e) => {
                  e.stopPropagation()
                }}
                style={{
                  height: '100%',
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  background: colors.neutral10Adjusted,
                }}
              >
                <IconButton
                  //  forceHover={open}
                  icon="more-vertical"
                  size="small"
                />
              </div>
            </Menu.Trigger>
            <Menu.Items>
              {itemActions.map((action) => (
                <Menu.Item
                  key={action.label}
                  leadIcon={action.icon}
                  onClick={() => {
                    action?.onClick(data)
                  }}
                  color={action.color}
                >
                  {action.label}
                </Menu.Item>
              ))}
            </Menu.Items>
          </Menu>
        </div>
      )}
      {Object.values(fields)
        .sort((a, b) => getFieldPriorityByType(a) - getFieldPriorityByType(b))
        .map((field, index) => {
          return (
            <div
              key={index}
              style={{ display: 'flex', minHeight: 24, alignItems: 'center' }}
            >
              {field.grid.type === 'media' ? (
                <div
                  style={{
                    width: '100%',
                    minHeight: 40,
                    borderRadius: radius[8],
                    background: colors.neutral10Adjusted,
                    border: `1px solid ${colors.neutral20Adjusted}`,
                    aspectRatio: 1,
                    overflow: 'hidden',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginBottom: 4,
                  }}
                >
                  <GridMediaItem
                    // data={
                    //   field.renderAccessorFn
                    //     ? field.renderAccessorFn(data)
                    //     : data
                    // }
                    data={data}
                  />
                </div>
              ) : field.render ? (
                <>
                  {field.render(
                    field.renderAccessorFn
                      ? field.renderAccessorFn(data)
                      : data,
                    'grid',
                  )}
                </>
              ) : field.grid.type === 'title' ? (
                <Text singleLine variant="display-medium" color="neutral100">
                  {data[field.key]}
                </Text>
              ) : (
                <Text singleLine variant="display-medium" color="neutral60">
                  {data[field.key]}
                </Text>
              )}
            </div>
          )
        })}
    </styled.div>
  )
}
